/** A time window as ISO times, closed at `from` and open at `to`. Either end may be left out. */
export interface TimeWindow {
    from?: string;
    to?: string;
}

/** A list table's date-range filter value, `[start, end]` as URI-encoded ISO times, or null when it is not a full range. A URL gives it back comma-joined. */
export function filterTimeWindow(value: any): TimeWindow | null {
    const values = (Array.isArray(value) ? value : String(value ?? '').split(','))
        .map((entry) => String(entry).trim())
        .filter((entry) => !!entry);
    const [from, to] = values.map((entry) => new Date(decodeURIComponent(entry)));
    if (!from || !to || !Number.isFinite(from.getTime()) || !Number.isFinite(to.getTime())) {
        return null;
    }
    return { from: from.toISOString(), to: to.toISOString() };
}
